export default __webpack_public_path__ + "static/media/UPS.4a42b015.png";